import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    id: string;
};

export const Svg = ({id, ...otherProps}: Props) => {
    return (
        <svg aria-hidden={`true`} {...otherProps}>
            <use href={`#${id}`} />
        </svg>
    );
};

Svg.displayName = "Svg";
